



















import { computed, defineComponent, ref, onUnmounted } from '@vue/composition-api';
import { MessagePlugin } from 'tdesign-vue';
import ipc from '@/renderer/scripts/utils/ipc';
export default defineComponent({
  setup(props, context) {
    const force = ref(true);
    const innerShow = ref(false);
    const innerType = ref('');
    const operate = ref('');
    const methods = {
      submit() {
        context.emit('onSubmit', {
          force: force.value ? 'overwrite' : 'ask',
        });
      },
    };
    const conflictDeal = (type: string, opt: string) => {
      MessagePlugin.closeAll();
      innerShow.value = true;
      innerType.value = type;
      operate.value = opt;
    };
    ipc.on(ipc.RENDERER_EVENTS_MAP.CONFLICT_SHOW, conflictDeal);
    const dealWay = async (command: string) => {
      innerShow.value = false;
      // 此处是复制和移动冲突时emit的事件
      const conflict_operate =
        operate.value === 'copy' ? ipc.RENDERER_EVENTS_MAP.CONFLICT_COPY : ipc.RENDERER_EVENTS_MAP.CONFLICT_MOVE;
      switch (command) {
        case 'rename':
          ipc.emit(conflict_operate, 'rename');
          break;
        case 'overwrite':
          ipc.emit(conflict_operate, 'overwrite');
          break;
        default:
          break;
      }
    };
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.CONFLICT_SHOW, conflictDeal);
    });
    return {
      innerShow,
      innerType,
      force,
      dealWay,
      operate,
      ...methods,
    };
  },
});
